module.exports = __webpack_public_path__ + "static/img/shop_environ_2.59aa8668.jpg";